import React from 'react';
import ConsistencySymbol from './ConsistencySymbol';
import ConsistencyWordmark from './ConsistencyWordmark';

/**
 * Consistency Brand Logo System
 * Uses inline SVG with exact gradient specifications
 * variant: 'symbol' | 'wordmark' | 'full'
 * size: 'sm' | 'md' | 'lg'
 */
export default function ConsistencyLogo({ 
  variant = 'full',
  size = 'md',
  className = ''
}) {
  const sizeMap = {
    sm: 24,
    md: 32,
    lg: 48
  };

  const pixelSize = sizeMap[size] || sizeMap.md;

  if (variant === 'symbol') {
    return <ConsistencySymbol size={pixelSize} className={className} />;
  }

  if (variant === 'wordmark') {
    return <ConsistencyWordmark height={pixelSize} className={className} />;
  }

  // Full lockup: symbol + wordmark
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <ConsistencySymbol size={pixelSize} />
      <ConsistencyWordmark height={pixelSize} />
    </div>
  );
}
